// extracted by mini-css-extract-plugin
export var circle = "_g0-1";
export var exitConfirmationModal = "_g0-5";
export var iframe = "_g0-0";
export var offline = "_g0-3";
export var online = "_g0-2";
export var workstationSelectError = "_g0-4";